export const TASK_TYPE_LIST_ITEM_ICON_HEIGHT = 16 // px

export const TASK_TYPE_LIST_ITEM_HEIGHT = 32 // px
